<template>
  <div class="media-item">
    <div class="comment">{{ comment }}</div>
    <media-gallery-item :item="item"></media-gallery-item>
  </div>
</template>

<script>

import MediaGalleryItem from '@/components/MediaGalleryItem';

export default {
  name: 'MediaItem',
  components: {
    MediaGalleryItem,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    comment() {
      return (this.item.video && this.item.video.comment) ||
        (this.item.image && this.item.image.comment) ||
        (this.item.audio && this.item.audio.comment);
    },
  },
};
</script>

<style scoped>

.comment {
  margin-bottom: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/MediaItem.vue